<template>
	<div>
		<NuxtLayout name="checkout">
			<DynamicComponent v-if="product" :path="templatePath" />
			<template #aside>
				<ProductMenu v-if="product" />
			</template>
		</NuxtLayout>
	</div>
</template>

<script lang="ts" setup>
import { definePageMeta, computed, useState } from "#imports";
import { useCheckoutStore } from "~/store/checkout";
import { storeToRefs } from "pinia";
import ProductMenu from "~/components/checkout/product-menu.vue";
import DynamicComponent from "~~/components/common/DynamicComponent.vue";
import { OrderStepType } from "~~/enums/orderStepType";
import { useNavigationStore } from "~~/store/navigation";

definePageMeta({ layout: "app", middleware: ['auth'] });

const step = useState("step");
const checkout = useCheckoutStore();
const navigation = useNavigationStore();
const { product } = storeToRefs(checkout);

const templatePath = computed(() => {
	return product.value && product.value.subscription_config ? product.value.subscription_config.template : null;
});

onMounted(async () => {
	step.value = navigation.getIndexStep(product?.value?.product_type, OrderStepType.SUBSCRIPTION);
});
</script>
